import React from 'react';
import PropTypes from 'prop-types';

const ExclusiveCard = ({ listing, agent, onSelectProperty, whatsappUrl }) => {
  const handleCardClick = () => {
    if (onSelectProperty) onSelectProperty(listing);
  };

  return (
    <div className="listing-card" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
      <div className="listing-image-container">
        <img src={listing.imageUrl} alt={listing.title} className="listing-image" />
        <span className={`listing-tag ${listing.listingType === 'FOR RENT' ? 'rent' : ''}`}>
          {listing.listingType}
        </span>
      </div>
      <div className="listing-content">
        <div className="listing-price">{listing.price}</div>
        <div className="listing-title" title={listing.title}>{listing.title}</div>
        <div className="listing-location" title={listing.area}>
          <i className="bi bi-geo-alt"></i> <span>{listing.area}</span>
        </div>
        {listing.date && (
          <div className="listing-date">
            <i className="bi bi-clock"></i> <span>Listed on {listing.date}</span>
          </div>
        )}

        <div className="listing-specs">
          <div className="spec-item" title="Bedrooms">
            <i className="bi bi-door-closed"></i> {listing.bedrooms}
          </div>
          <div className="spec-item" title="Bathrooms">
            <i className="bi bi-droplet"></i> {listing.bathrooms}
          </div>
          <div className="spec-item" title="Dimensions / Size">
            <i className="bi bi-aspect-ratio"></i> {listing.size}
          </div>
        </div>

        <div className="listing-actions">
          <button 
            className="btn-view-details"
            onClick={(e) => {
              e.stopPropagation();
              if (onSelectProperty) onSelectProperty(listing);
            }}
          >
            VIEW DETAILS
          </button>
          <a 
            href={whatsappUrl} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-whatsapp-icon"
            title="Enquire on WhatsApp"
            onClick={(e) => e.stopPropagation()}
          >
            <i className="bi bi-whatsapp"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

ExclusiveCard.propTypes = {
  listing: PropTypes.object.isRequired,
  agent: PropTypes.object,
  onSelectProperty: PropTypes.func,
  whatsappUrl: PropTypes.string.isRequired,
};

export default ExclusiveCard;
